import moment from 'moment';
import { JsonWorkDayModel, WorkdayModel, WorkdayModelFromJson } from '../low-level/workday.model';

export class WorkWeekdayModel {
    public workdayModelList: WorkdayModel[] = [];
    public currentWeek: number;
    public timeStamp: number;

    public constructor(data: WorkdayModel[], timeStamp = 0, currentWeek?: number) {
        this.workdayModelList = data;
        this.timeStamp = timeStamp;
        if (typeof currentWeek === 'undefined') {
            this.currentWeek = moment().isoWeek();
            return;
        }
        this.currentWeek = currentWeek;
    }
}

export class WorkWeekdayModelFromJson extends WorkWeekdayModel {
    public constructor(data: JsonWorkWeekdayModel) {
        super(
            data.workdayModelList
                ? data.workdayModelList.map((jsonWorkDayModel) => new WorkdayModelFromJson(jsonWorkDayModel))
                : [],
            data.timeStamp,
            data.currentWeek,
        );
    }
}

export interface JsonWorkWeekdayModel {
    workdayModelList: JsonWorkDayModel[];
    currentWeek: number;
    timeStamp: number;
}
